// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"styles_primaryButton__KzqiU","buttonContentLoading":"styles_buttonContentLoading__1Ppre","loadingIcon":"styles_loadingIcon__xW7B-"};